import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetProducts,
  builderGetProductsCategories,
  builderGetProductsSubCategories
} from './reducer';

const initialState: any = {
  categories: [],
  categoriesLoading: false,
  categoriesError: '',
  subCategories: [],
  subCategoriesLoading: false,
  subCategoriesError: '',
  products: {},
  productsLoading: false,
  productsError: ''
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    resetCategories(state: any) {
      state.categories = initialState.categories;
    },
    resetSubCategories(state: any) {
      state.subCategories = initialState.subCategories;
    },
    resetProducts(state: any) {
      state.products = initialState.products;
    }
  },
  extraReducers: (builder) => {
    builderGetProductsCategories(builder);
    builderGetProductsSubCategories(builder);
    builderGetProducts(builder);
  }
});

export const {resetCategories, resetSubCategories, resetProducts} = productsSlice.actions;

export default productsSlice.reducer;
